import { css, jsx } from '@emotion/core';
import { Col, Row, Select } from 'antd';
import React from 'react';

import Form from '@/src/shared/components/Form';
import LoadingResults from '@/src/shared/components/LoadingResults';
import Pagination from '@/src/shared/components/Pagination';
import ResultCard from '@/src/shared/components/ResultCard';
import { form as formStyle, space } from '@/styles';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';

const { m } = space;

const { Option } = Select;
const style = {
  select: css`
    width: 100%;
  `,
  gridContainer: css`
    ${formStyle.gridRow};
    font-size: 1.6rem;
  `,
  label: css`
    font-weight: bolder;
  `,
  noPrint: css`
    @media print {
      display: none;
    }
  `,
};

const selectProps = {
  size: 'large',
  optionFilterProp: 'children',
  showSearch: true,
};

const sortOrderOptions = [
  {
    name: 'Ascending',
    value: 'ASC',
  },
  {
    name: 'Descending',
    value: 'DESC',
  },
];

const sortFieldOptions = [
  {
    name: 'Case Name',
    value: 'CASENAME',
  },
  {
    name: 'Date',
    value: 'CASEREQUESTDATE',
  },
  {
    name: 'Case Status',
    value: 'STATUSDESCRIPTION',
  },
  {
    name: 'State',
    value: 'STATEDESCRIPTION',
  },
];
const SearchResults = props => {
  const {
    currentPage,
    form,
    sortField,
    sortOrder,
    searchData: { results, count, isFetchingResults },
    searchCriteria,
    handlePageChange,
    handleSortOrder,
    handleSortField,
  } = props;
  const { States, Issues, Statuses } = searchCriteria;

  const renderRow = (label, data) => {
    return (
      <div css={style.gridContainer}>
        <p css={style.label}>{`${label}:`}</p>
        <p>{data}</p>
      </div>
    );
  };

  const pagination = (
    <Pagination
      current={currentPage.page}
      total={count}
      pageSize={10}
      onChange={p => {
        handlePageChange(p);
      }}
      css={css`
        margin-bottom: 24px;
        @media print {
          display: none;
        }
      `}
    />
  );
  const sortFieldSelect = (
    <Select
      css={[style.select]}
      placeholder="Sort Field"
      disabled={!count}
      {...selectProps}
      onChange={e => {
        handleSortField(e);
      }}
    >
      {sortFieldOptions.map(s => (
        <Option key={s.value} value={s.value}>
          {s.name}
        </Option>
      ))}
    </Select>
  );
  const sortOrderSelect = (
    <Select
      css={[style.select]}
      placeholder="Sort Order"
      disabled={!count}
      {...selectProps}
      onChange={e => {
        handleSortOrder(e);
      }}
    >
      {sortOrderOptions.map(s => (
        <Option key={s.value} value={s.value}>
          {s.name}
        </Option>
      ))}
    </Select>
  );

  return (
    <div>
      <Row type="flex" css={style.noPrint}>
        <Col>{count > 0 && pagination}</Col>
      </Row>
      <Row gutter={16} css={style.noPrint}>
        <Form>
          <Col xs={24} md={8}>
            <Form.Item label="Sort Field">
              {form.getFieldDecorator('SortField', { initialValue: sortField })(sortFieldSelect)}
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item label="Sort Order">
              {form.getFieldDecorator('SortOrder', { initialValue: sortOrder })(sortOrderSelect)}
            </Form.Item>
          </Col>
        </Form>
      </Row>
      <Row type="flex" gutter={{ xs: 24, md: 32 }} css={m.b24} />
      <div>
        {isFetchingResults ? (
          <LoadingResults height={400} />
        ) : (
          <div>
            {results.map(r => (
              <ResultCard
                iconVisible={false}
                as={`/advocacy/legal-judicial-advocacy/named-party/${r.LegalCaseId}`}
                href="/advocacy/legal-judicial-advocacy/named-party/[slug]"
                title={r.CaseName}
                summary={
                  <div>
                    {renderRow('Date', convertMomentToDate(r.DateCreated))}
                    {renderRow('Case Status', r.Status)}
                    {renderRow('State', r.StateDescription)}
                    {renderRow('Issues', r.Issues.map(i => i.IssueName).join(', '))}
                  </div>
                }
              />
            ))}
          </div>
        )}
      </div>
      <Row type="flex" css={style.noPrint}>
        <Col>{count > 0 && pagination}</Col>
      </Row>
    </div>
  );
};

SearchResults.propTypes = {};

SearchResults.defaultProps = {
  results: [],
  currentPage: 1,
  sortOrder: 'ASC',
  sortField: 'CASENAMES',
  handlePageChange: () => {},
  handleSortOrder: () => {},
  handleSortField: () => {},
  isFetchingResults: false,
};

export default Form.create({ name: 'SortForm' })(SearchResults);
